import React, { useContext, useEffect, useState } from 'react';

import { Tabs } from 'flowbite';

import { PacksContext, PacksDispatchContext } from './ApiProvider';
import CategoriesToPacks from './CategoriesToPacks';
import ExpensePacksDashboard from './ExpensePacksDashboard';
import ItemsToPacks from './ItemsToPacks';
import PackItemsByCategory from './PackItemsByCategory';
import PackItemsImportBar from './PackItemsImportBar';
import PacksToVenues from './PacksToVenues';

import Button from 'CommonComponents/Button';

export default function SimplePacks(props) {
    const [tabs, setTabs] = useState(null);
    const [isAddItemButtonVisible, setIsAddItemButtonVisible] = useState(null);
    const [isAddPackButtonVisible, setIsAddPackButtonVisible] = useState(false);
    const [isAddCategoryButtonVisible, setIsAddCategoryButtonVisible] = useState(false);

    const apiCall = useContext(PacksDispatchContext);
    const { simplePackItems, simplePacks, simplePackCategories, isLoaded, isSaving } = useContext(PacksContext);

    const fetchUrl = () => {
        const url = new URL(props.fetchDashboardUrl);
        url.searchParams.set('type', 'simple');

        return url.toString();
    };

    useEffect(function () {
        const tabsElement = $('#simple-packs-tabs');
        const tabElements = [
            {
                id: 'dashboard-simple-pack',
                triggerEl: document.querySelector('#dashboard-simple-pack-tab'),
                targetEl: document.querySelector('#dashboard-simple-pack'),
            },
            {
                id: 'simple-pack-categories',
                triggerEl: document.querySelector('#simple-pack-categories-tab'),
                targetEl: document.querySelector('#simple-pack-categories'),
            },
            {
                id: 'simple-pack-items',
                triggerEl: document.querySelector('#simple-pack-items-tab'),
                targetEl: document.querySelector('#simple-pack-items'),
            },
            {
                id: 'simple-pack-packs',
                triggerEl: document.querySelector('#simple-pack-packs-tab'),
                targetEl: document.querySelector('#simple-pack-packs'),
            },
            {
                id: 'simple-pack-assign-venues',
                triggerEl: document.querySelector('#simple-pack-assign-venues-tab'),
                targetEl: document.querySelector('#simple-pack-assign-venues'),
            },
        ];
        const options = {
            defaultTabId: 'dashboard-simple-pack',
            activeClasses: 'active',
            inactiveClasses: 'inactive',
            onShow: (tabs, tab) => {
                setIsAddItemButtonVisible(tab.id === 'simple-pack-items');
                setIsAddPackButtonVisible(tab.id === 'simple-pack-packs');
                setIsAddCategoryButtonVisible(tab.id === 'simple-pack-categories');
            },
        };
        const instanceOptions = {
            id: 'simple-packs-tabs',
            override: true,
        };
        const tabs = new Tabs(tabsElement, tabElements, options, instanceOptions);

        setTabs(tabs);
    }, []);

    const handlePackItemEdit = (id) => {
        apiCall('form', {
            type: 'createSimpleItem',
            id,
        });
    };

    const handleAddItem = () => {
        const activeTab = tabs.getActiveTab();

        if (activeTab.id === 'simple-pack-items') {
            apiCall('form', { type: 'createSimpleItem' });
        } else if (activeTab.id === 'simple-pack-packs') {
            apiCall('form', { type: 'createSimplePack' });
        }
    };

    const handleAddCategory = () => {
        apiCall('form', { type: 'createSimpleCategory' });
    };

    return (
        <div className="tw-flex tw-flex-col tw-h-full tw-space-y-6">
            <div
                className="in-nav horizontal"
                data-tabs-active-classes="active"
                data-tabs-inactive-classes="inactive"
                data-default-tab-id="simple-pack-items-tab"
                data-tabs-toggle="#simple-packs-tab-content"
                role="tablist"
                id="simple-packs-tabs"
            >
                <button
                    className="in-nav__item"
                    id="dashboard-simple-pack-tab"
                    data-tabs-target="#dashboard-simple-pack"
                    type="button"
                    role="tab"
                    aria-controls="dashboard-simple-pack"
                    aria-selected="true"
                >
                    {$t('Dashboard')}
                </button>
                <button
                    className="in-nav__item"
                    id="simple-pack-categories-tab"
                    data-tabs-target="#simple-pack-categories"
                    type="button"
                    role="tab"
                    aria-controls="simple-pack-categories"
                    aria-selected="true"
                >
                    {$t('Categories')}
                </button>
                <button
                    className="in-nav__item"
                    id="simple-pack-items-tab"
                    data-tabs-target="#simple-pack-items"
                    type="button"
                    role="tab"
                    aria-controls="simple-pack-items"
                    aria-selected="true"
                >
                    {$t('Items')}
                </button>
                <button
                    className="in-nav__item"
                    id="simple-pack-packs-tab"
                    data-tabs-target="#simple-pack-packs"
                    type="button"
                    role="tab"
                    aria-controls="simple-pack-packs"
                    aria-selected="false"
                >
                    {$t('Cost Packs')}
                </button>
                <button
                    className="in-nav__item"
                    id="simple-pack-assign-venues-tab"
                    data-tabs-target="#simple-pack-assign-venues"
                    type="button"
                    role="tab"
                    aria-controls="simple-pack-assign-venues"
                    aria-selected="false"
                >
                    {$t('Assign to Venue')}
                </button>

                {!!window.canSave && (isAddItemButtonVisible || isAddPackButtonVisible || isAddCategoryButtonVisible) && (
                    <div className="tw-flex tw-items-center tw-gap-x-1 !tw-ml-auto">
                        {isAddCategoryButtonVisible ? (
                            <Button small variant="primary" disabled={isSaving} onClick={handleAddCategory}>
                                {$t('Add Category')}
                            </Button>
                        ) : (
                            <Button small variant="primary" disabled={isSaving} onClick={(e) => handleAddItem()}>
                                {isAddPackButtonVisible ? $t('Add Pack') : $t('Add Item')}
                            </Button>
                        )}
                    </div>
                )}
            </div>

            <div id="simple-packs-tab-content" className="tw-min-h-0">
                <div id="dashboard-simple-pack" role="tabpanel" aria-labelledby="dashboard-simple-pack-tab">
                    <ExpensePacksDashboard fetchDashboardUrl={fetchUrl()} />
                </div>
                <div id="simple-pack-items" className="tw-h-full" role="tabpanel" aria-labelledby="simple-pack-items-tab">
                    <div className="tw-flex tw-flex-col tw-h-full tw-space-y-2 tw-overflow-auto tw-w-2/3 max-lg:tw-w-full">
                        {!!window.canSave && <PackItemsImportBar type="simple" />}
                        <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-bg-white tw-sticky tw-top-0 tw-z-10">
                            <div className="tw-p-2.5 tw-flex tw-gap-2 tw-text-sm tw-font-semibold tw-text-charcoal">
                                <div className="tw-basis-full tw-shrink tw-grow">
                                    <div>{$t('Description')}</div>
                                </div>
                                <div className="tw-basis-full tw-shrink tw-grow">
                                    <div className="tw-text-center">{$t('Unit Price')}</div>
                                </div>
                                {!!simplePackItems.some((item) => item.can_be_edited) && <div className="tw-basis-6 tw-shrink-0"></div>}
                            </div>
                        </div>
                        <PackItemsByCategory items={simplePackItems} categories={simplePackCategories} type="simple" onEdit={handlePackItemEdit} />
                    </div>
                </div>
                <div id="simple-pack-packs" className="tw-h-full" role="tabpanel" aria-labelledby="simple-pack-packs-tab">
                    <ItemsToPacks items={simplePackItems} packs={simplePacks} isLoaded={isLoaded} />
                </div>
                <div id="simple-pack-assign-venues" className="tw-h-full" role="tabpanel" aria-labelledby="simple-pack-assign-venues-tab">
                    <PacksToVenues packs={simplePacks} />
                </div>
                <div id="simple-pack-categories" className="tw-h-full" role="tabpanel" aria-labelledby="simple-pack-categories-tab">
                    <CategoriesToPacks categories={simplePackCategories} isContractor={false} isLoaded={isLoaded} />
                </div>
            </div>
        </div>
    );
}
